import { MY_TRIP, BOOKING_DETAIL } from "./action";

const initialState = {
    myTrips: null,
    bookingDetail: null,
    loadOn: null,
};
function transactionReducer(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case MY_TRIP:
            return { ...state, myTrips: action.payload };
        case BOOKING_DETAIL:
            return { ...state, bookingDetail: action.payload };
        default:
            return state;
    }
}
export default transactionReducer;